import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAverageLabelPrice = {
  name: "getAverageLabelPrice" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
